import { HighlightOff } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

import locales from '../../../../../../../constants/locales';
import DetailsList from '../../../../../../common/details-list';
import { formatToAmount } from '../../../../../../../constants/helpers/utils';
import { detailsValueFormatter } from '../../../../../../../utils/details';
import DetailsFactory from '../../../../../../common/details-list/detailsFactory';

import { OperationFailed } from './interfaces';

interface Props {
  operation: OperationFailed;
}

const FailureOperation = ({ operation }: Props) => {
  const theme = useTheme();
  const { details, cost, customerMsisdn } = operation;

  const error = details.failureCause ? { errorMessage: details.failureCause } : undefined;

  return (
    <DetailsFactory
      header={{
        icon: { component: HighlightOff, color: theme.palette.error.main },
        id: operation.id,
        date: operation.date,
        status: operation.status
      }}
      error={error}
      operationContent={
        <DetailsList
          items={[
            { label: locales.operation.label.providerName, value: detailsValueFormatter(details.providerName) },
            {
              label: locales.operation.label.authenticationMethod,
              value: detailsValueFormatter(details.authenticationMethod)
            },
            {
              label: locales.operation.label.customerMsisdn,
              value: detailsValueFormatter(customerMsisdn)
            },
            { label: locales.operation.label.cost, value: formatToAmount(cost.value) }
          ]}
        />
      }
    />
  );
};

export default FailureOperation;
